import React from 'react'
import Text from './Text'
import Counter from './Counter'
import { formatValue } from 'shared/utils'
import { Box as MuiBox } from '@material-ui/core'
import { Pause as PauseIcon } from '@material-ui/icons'
import moment from 'moment'

export function DurationCounterView({ t }) {
  if (!t) return null

  const now = moment()
  const startedAt = t?.started_at
  const pausedAt = t?.paused_at
  const resumedAt = t?.resumed_at
  const stoppedAt = t?.stopped_at
  const expiry = t?.expiry_time ? moment(t.expiry_time) : null
  const hasTarget = typeof t.target_time === 'number' && t.target_time > 0

  const baseElapsed = (typeof t.total_elapsed === 'number' && !isNaN(t.total_elapsed))
    ? Math.floor(t.total_elapsed)
    : 0

  const isPaused = Boolean(pausedAt)
  const isStopped = Boolean(stoppedAt)

  /** style defaults */
  let color = '#000'
  let bg = '#E0'
  let prefix = ''
  let style = { color, fontSize: '0.8125rem', fontWeight: '500', backgroundColor: bg, padding: '0 10px', borderRadius: '4px' }

  if (isStopped) {
    /** prefer total_elapsed; fallback to stopped_at - started_at */
    const durationSeconds = (baseElapsed > 0)
      ? baseElapsed
      : (startedAt && stoppedAt)
        ? Math.floor((new Date(stoppedAt) - new Date(startedAt)) / 1000)
        : 0

    style.color = '#000'
    style.backgroundColor = '#E0'

    if (t?.target_time > 0 && durationSeconds > t?.target_time) {
      style.color = '#950000'
      style.backgroundColor = '#ffa199'
    }

    if (style.backgroundColor === '#E0') {
      style.padding = '0px'
    }

    return (
      <div style={{ display: 'flex' }}>
        <MuiBox>
          <Text variant="body2" noWrap={true} textCustomProps={style}>
            {formatValue(durationSeconds, 'duration')}
          </Text>
        </MuiBox>
      </div>
    )
  }

  if (isPaused) {
    /** prefer total_elapsed; fallback to paused_at - started_at */
    const durationSeconds = (baseElapsed > 0)
      ? baseElapsed
      : (startedAt && pausedAt)
        ? Math.floor((new Date(pausedAt) - new Date(startedAt)) / 1000)
        : 0

    style.color = '#0000008A'
    style.backgroundColor = '#f2f2f2'
    style.paddingLeft = '5px'

    return (
      <div style={{ display: 'flex' }}>
        <Text variant="body2" noWrap={true}>
          {formatValue(durationSeconds, 'duration')}
        </Text>
      </div>
    )
  }

  let startProp = undefined
  let endProp = undefined

  if (expiry && hasTarget) {
    if (now.isBefore(expiry)) {
      startProp = undefined
      endProp = expiry.toISOString()
      color = '#006644'
      bg = '#e3fcef'
      prefix = ''
    } else {
      startProp = expiry.toISOString()
      endProp = undefined
      color = '#950000'
      bg = '#ffa199'
      prefix = '-'
    }
  } else if (startedAt || resumedAt) {
    /** count-up from resumed_at (or started_at on first run); add baseElapsed */
    startProp = resumedAt ?? startedAt
    endProp = undefined
    if (hasTarget) {
      color = '#006644'
      bg = '#e3fcef'
    } else {
      style.padding = '0px'
    }
    prefix = ''
  } else {
    /** fallback if nothing to show */
    style.color = '#000'
    style.backgroundColor = '#E0'
    return (
      <div style={{ display: 'flex' }}>
        <MuiBox>
          <Text variant="body2" noWrap={true} textCustomProps={style}>
            -
          </Text>
        </MuiBox>
      </div>
    )
  }

  style.color = color
  style.backgroundColor = bg

  return (
    <div style={{ display: 'flex' }}>
      <MuiBox>
        <Counter
          start={startProp}
          end={endProp}
          baseElapsedSeconds={baseElapsed}
          style={style}
          prefix={prefix}
          short
        />
      </MuiBox>
    </div>
  )
}

export default DurationCounterView
